import { render, staticRenderFns } from "./congestion-level.vue?vue&type=template&id=496502f1&scoped=true&"
import script from "./congestion-level.vue?vue&type=script&lang=ts&"
export * from "./congestion-level.vue?vue&type=script&lang=ts&"
import style0 from "./congestion-level.vue?vue&type=style&index=0&id=496502f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496502f1",
  null
  
)

export default component.exports